import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider, Toolbar } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useDocTypes } from '@/providers/DocTypesContext';
import { useLocation, useNavigate } from 'react-router';
import AdminDocumentList from './AdminDocumentList';

function AdminDocuments(): React.JSX.Element {
  const doc_types = useDocTypes();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get('type');

  // Set initial tab based on URL parameter or default to first tab
  useEffect(() => {
    if (doc_types && tab) {
      const tabIndex = doc_types.findIndex((doc_type) => doc_type.code === tab);
      if (tabIndex !== -1) {
        setSelectedTab(tabIndex);
      }
    }
  }, [doc_types, tab]);

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    if (doc_types && doc_types[newValue]) {
      setSelectedTab(newValue);
      navigate(`?type=${doc_types[newValue].code}`);
    }
  };

  console.log(doc_types);
  return (
    <>
      <Toolbar
        sx={{
          minHeight: '55px !important',
        }}
      >
        <Typography variant='h6' sx={{ mr: 4 }}>
          Documents
        </Typography>
      </Toolbar>
      <Divider />

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={selectedTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={handleTabChange}
              variant='scrollable'
              scrollButtons='auto'
              aria-label='Document Types'
            >
              {doc_types?.map((doc_type, index) => (
                <Tab
                  key={doc_type.entity_id}
                  label={doc_type.name}
                  value={index}
                  id={`doc-tab-${index}`}
                  aria-controls={`doc-tabpanel-${index}`}
                />
              ))}
            </TabList>
          </Box>
          {doc_types?.map((doc_type, index) => (
            <TabPanel
              key={doc_type.entity_id}
              value={index}
              id={`doc-tabpanel-${index}`}
              aria-labelledby={`doc-tab-${index}`}
            >
              <AdminDocumentList doc_type={doc_type} />
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </>
  );
}

export default AdminDocuments;
